import { IFieldProps } from '../../interfaces'
import { TextField } from "@mui/material";
import { context } from '../..';
import { observer } from 'mobx-react-lite';
import FieldSelect from './FieldSelect';
import FieldRadio from './FieldRadio';
import FieldDate from './FieldDate';
import FieldAttachment from './FieldAttachment';
import FieldPhone from './FieldPhone';
import Table from './Table';


export default observer(function Field ({field, formik, autoFocus = false}: IFieldProps) {

    const label = context.formatLabel(field.label)

    switch (field.type) {
        case "fixed-value":
            return <></>
        case "file":
            return <FieldAttachment key={formik.values[field.name]} formik={formik} field={field} />
        
        case "phone-number":
            return <FieldPhone formik={formik} field={field} autoFocus={autoFocus} />

        case "radio":
            return <FieldRadio formik={formik} field={field} autoFocus={autoFocus} />

        case "select":
            return <FieldSelect formik={formik} field={field} autoFocus={autoFocus} />

        case "date":
            return <FieldDate formik={formik} field={field} autoFocus={autoFocus} />

        case "div":
            if (label === null || label.includes("{")) {
                return <></>
            }
            return <div dangerouslySetInnerHTML={{__html: label}}></div>
  
        case "checkbox":
            return (
                <div className="form-field field-checkbox">
                    <label>
                        <input
                            name={field.name}
                            checked={formik.values[field.name] === "true"}
                            type="checkbox"
                            onChange={(e) => {
                                formik.setFieldValue(field.name, formik.values[field.name] === "true" ? "false" : "true")
                            }}
                        />
                        <span className="field-checkbox-label-content">{label}</span>
                    </label>

                    {field.helpText ? <span className="help-text">{field.helpText}</span> : null}
                </div>
            )

        case "table":
            return (
                <Table
                    table={field.table} 
                    onChange={(values) => {
                        context.submitPageAnswers(values, false)
                    }} /> 
            )
        case "number":
        case "text-area":
        default:

            var len = formik.values[field.name]?.length

            return (
                <div className="form-field" style={{display: "grid", gap: "2px"}}>
                    <TextField
                        name={field.name}
                        value={formik.values[field.name]}
                        label={label}
                        type={field.type === "number" ? "number" : "text"}
                        variant={field.type === "text-area" ? "filled" : "standard"}
                        multiline={field.type === "text-area"}
                        rows={field.type === "text-area" ? 4 : 1}
                        autoFocus={autoFocus}
                        error={formik.submitCount && formik.errors[field.name] ? formik.errors[field.name] : false}
                        onChange={(e) => {
                            // Remove any bullet points
                            if (e.target.value?.includes("•")) {
                                e.target.value = e.target.value.replaceAll("•", "-")
                            }
                            if (e.target.value?.includes("\t")) {
                                e.target.value = e.target.value.replaceAll("\t", " ")
                            }
                            formik.handleChange(e)
                        }}/>

                    {field.type === "text-area" ? <span className="help-text">{len ? len : 0} characters</span> : null}

                    {field.helpText ? <span className="help-text">{field.helpText}</span> : null}
                </div>
            )
    }
})